<template>
  <zj-layout-container>
    <zj-layout-header>
      <div class="listtitle">任务信息详情</div>
    </zj-layout-header>
    <zj-layout-main>
      <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
          v-loading="loading"
          :element-loading-text="loadingText"
          
        >
          <el-row>
            <el-col>
              <el-form-item label="任务名称" prop="ProjectTaskName">
                <el-input v-model="data.ProjectTaskName" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="开始时间" prop="ProjectTaskStartTime">
                <el-date-picker
                  type="datetime"
                  style="width: 100%"
                  placeholder="选择日期" :disabled="!IsEdit"
                  v-model="data.ProjectTaskStartTime"
                  format="yyyy-MM-dd hh:mm"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结束时间" prop="ProjectTaskEndTime">
                <el-date-picker
                  type="datetime"
                  style="width: 100%" :disabled="!IsEdit"
                  placeholder="选择日期"
                  v-model="data.ProjectTaskEndTime"
                  format="yyyy-MM-dd hh:mm"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="任务详情" prop="ProjectTaskDescription">
              <el-input :disabled="!IsEdit"
                v-model="data.ProjectTaskDescription"
                type="textarea"
                :autosize="{ minRows: 4 }"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="任务执行方" prop="ProjectTaskExcute">
                <el-input v-model="data.ProjectTaskExcute" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="任务负责人" prop="ProjectTaskCharger">
                <el-input v-model="data.ProjectTaskCharger" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="任务负责人手机" prop="ProjectTaskExcutePhone">
                <el-input v-model="data.ProjectTaskExcutePhone" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="验收方" prop="ProjectTaskCheckOrg">
                <el-input v-model="data.ProjectTaskCheckOrg" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="验收负责人" prop="ProjectTaskChecker">
                <el-input v-model="data.ProjectTaskChecker" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="验收负责人手机" prop="ProjectTaskCheckPhone">
                <el-input v-model="data.ProjectTaskCheckPhone" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="assocID">
            <FileList :assocID="assocID" :module="module" :submodule="submodule"></FileList>
          </el-row>
        </el-form>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <el-form>
        <el-form-item class="right" style="width: 134rem;padding-right:5rem">
          <el-button @click="onBack()">返回</el-button>
          <el-button type="primary" @click="saveForm()" v-show="IsEdit">保存</el-button>
        </el-form-item>
      </el-form>
    </zj-layout-footer>
  </zj-layout-container>
</template>


<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";
import FileList from "../MaterialManage/FileList";
export default {
  name: "ProjectTaskInfo",
  controller: "UI",
  action: "ProjectTaskInfo",
  components: {
    FileList,
  },
  data() {
    return {
      data: { ProjectID: "" },
      assocID: "",
      module: "",
      submodule: "",
      loading: false,
      loadingText: "加载中...",
      IsEdit: true,
      rules: {
        ProjectTaskName: [
          { required: true, message: "请输入任务名称", trigger: "blur" },
        ],
        ProjectTaskStartTime: [
          { required: true, message: "请选择开始时间", trigger: "blur" },
        ],
        ProjectTaskEndTime: [
          { required: true, message: "请选择结束时间", trigger: "blur" },
        ],
        ProjectTaskDescription: [
          { required: true, message: "请输入任务详情", trigger: "blur" },
        ],
        ProjectTaskExcute: [
          { required: true, message: "请输入任务执行方", trigger: "blur" },
        ],
        ProjectTaskCharger: [
          { required: true, message: "请输入任务负责人", trigger: "blur" },
        ],
        ProjectTaskExcutePhone: [
          { required: true, message: "请输入任务负责人手机", trigger: "blur" },
        ],
        ProjectTaskCheckOrg: [
          { required: true, message: "请输入验收方", trigger: "blur" },
        ],
        ProjectTaskChecker: [
          { required: true, message: "请输入验收负责人", trigger: "blur" },
        ],
        ProjectTaskCheckPhone: [
          { required: true, message: "请输入验收负责人手机", trigger: "blur" },
        ],
      },
    };
  },
  created: function () {},
  mounted: function () {
    if (this.$route.query.InfoId) {
      this.assocID = this.$route.query.InfoId;
      this.search();
    }
    if (this.$route.query.module) {
      this.module = this.$route.query.module;
    }
    if (this.$route.query.submodule) {
      this.submodule = this.$route.query.submodule;
    }
    if (this.$route.query.ProjectID) {
      this.data.ProjectID = this.$route.query.ProjectID;
    }
    if (this.$route.query.IsEdit!=null) {
      this.IsEdit = this.$route.query.IsEdit;
    }
  },
  methods: {
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.loadingText = "保存中...";
          if (this.$route.query.type == "add") {
            this.Add();
          } else if (this.$route.query.type == "edit") {
            this.Edit();
          }
        } else {
          return false;
        }
      });
    },
    Add() {
      this.data.ID = ZJApp.ZJUtils.uuid();
      this.data.Validity = 1;
      this.data.CreateTime = new Date();
      this.data.Creater = ZJApp.ZJUser.current.UserName;
      new MyApis.ProjectTaskApi()
        .AddItem(this.data)
        .then((r) => {
          r = r.data.Data;
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！",
          });
          this.loading = false;
          this.$router.go(-1); //返回上一层
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    Edit() {
      this.data.ModifyTime = new Date();
      this.data.Modifier = ZJApp.ZJUser.current.UserName;
      new MyApis.ProjectTaskApi()
        .UpdateItem(this.data)
        .then((r) => {
          r = r.data.Data;
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！",
          });
          this.loading = false;
          this.$router.go(-1); //返回上一层
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        this.loading = true;
        new MyApis.ProjectTaskApi()
          .GetItemById({ ID: InfoId })
          .then((r) => {
            r = r.data.Data;
            this.data = r;
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
  },
};
</script>
